// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3O_-m","title":"FrontImage_title__1u30e"};